// extracted by mini-css-extract-plugin
export default {"submitFormWorkaround":"ionicCss_submitFormWorkaround__2bx5h"};